import React, {Component} from 'react';
import {Button, Modal, Grid, Form, Image, Card} from 'semantic-ui-react';
import update from 'react-addons-update';

import StoreCategoryData from "../../data/StoreCategoryData";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {categoryDialog} from "../../actions/CategoryDialogActions";
import {selectCategory} from "../../actions/CategorySelectActions";
import localDB from "../../data/localDB";

class CategoryDialog extends Component {

    constructor() {
        super();

        this.state = {
            category: {
                name: "",
                id: null,
                image_url: null,
                file: null,
                active: true,
                show_in_menu: true
            },
            nameError: false,
            submittedValues: null,
            sending: false
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.category_dialog){
            if(nextProps.category_dialog.category['image_url']){
                nextProps.category_dialog.category['image_url'] = nextProps.category_dialog.category['image_url'] + '?tr=w-300,ar-16-9'
            }

            this.setState({category:nextProps.category_dialog.category});
        }
    }

    errorValidator = ( values ) => {
      const validateFirstName = ( name ) => {
        return !name;
      };
      return {
        name: validateFirstName( values.name )
      };
    };

    updateLabels = (category) => {
        if (category) {
            category.file=null;
            this.setState({
                title: "Actualizar Categoría",
                label_button: "Actualizar información",
                category,
                name_error: false
            });
        } else {
            this.setState({
                title: "Nueva Categoría",
                label_button: "Guardar información",
                name_error: false,
                category: {
                    name: "",
                    id: null,
                    active: true
                }
            });
        }
    };

    handleNameChange = (event) => {
        let name = update(this.state, {
            category: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(name);
        if (event.target.value.trim() === '') {
            this.setState({name_error: true});
        } else {
            this.setState({name_error: false});
        }
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.category.name === "") {
            this.setState({name_error: true});
        } else {
            this.setState({sending: true});
            if (this.state.category.id) {
                StoreCategoryData.updateCategoryStore(this.state.category, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Categoría Actualizada!');
                        localDB.addOrUpdateList('categories', res);
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({sending: false, open: false});
                });
            } else {
                StoreCategoryData.addCategoryStore(this.state.category, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Categoría Agregada!');
                        localDB.addOrUpdateList('categories', res);
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({sending: false, open: false});
                });
            }
        }
    };

    handleActive = () => {
        let active = update(this.state, {
            category: {
                active: {
                    $set: !this.state.category.active
                }
            }
        });
        this.setState(active);
    };

    handleShowInMenu = () => {
        let show_in_menu = update(this.state, {
            category: {
                show_in_menu: {
                    $set: !this.state.category.show_in_menu
                }
            }
        });
        this.setState(show_in_menu);
    };

    handleClose = () => {
        this.props.categoryDialog({open: false, category:{id:null}});
    };

    handleImageChange = (e) => {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            let category = update(this.state, {
                category: {
                    image_url: {
                        $set: reader.result
                    },
                    file: {
                        $set: file
                    }
                }
            });
            this.setState(category);
        };
        
        if(file){
            reader.readAsDataURL(file)
        }
    };

    openFileDialog = () => {
        this.refs.fileUpload.click();
    };

    dispatchData = (category, message) => {
        this.props.selectCategory(category);
        this.props.categoryDialog({open:false, category:{id: null, name: '', image:null}});
        this.props.showToast({message: message, type: 'success'});
    };

    render() {
        return (
            <div>
                <Modal size='tiny' dimmer='inverted' open={this.props.category_dialog.open} onClose={this.handleClose}>
                    <Modal.Header>{this.props.category_dialog.category.id ? 'Actualizar Categoría':'Nueva Categoría'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Input label='Nombre' placeholder='Nombre' value={this.state.category.name} onChange={this.handleNameChange} error={this.state.name_error} />
                                            <input
                                                ref="fileUpload"
                                                type="file"
                                                style={{"display": "none"}}
                                                accept=".png, .jpg, .jpeg"
                                                onChange={this.handleImageChange}
                                            />
                                            <Form.Checkbox label='Categoría activa' checked={this.state.category.active} onChange={this.handleActive} />
                                            <Form.Checkbox label='Mostrar en el menú digital' checked={this.state.category.show_in_menu} onChange={this.handleShowInMenu} />
                                            {this.state.category.image_url ?<Card raised key={this.state.category.id}>
                                                <Image src={`${this.state.category.image_url}`} height='120'/>
                                                <Card.Content extra>
                                                    <Button primary fluid content='Cambiar Imagen' icon='image' labelPosition='left'
                                                            onClick={this.openFileDialog}/>
                                                </Card.Content>
                                            </Card>:<Button fluid icon='upload' labelPosition='left' onClick={this.openFileDialog} content='Agregar Imagen'/>}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' disabled={this.state.sending} loading={this.state.sending} labelPosition='left' onClick={this.handleSubmit} content={this.props.category_dialog.category.id ? 'Actualizar':'Guardar'} />
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        category_dialog: state.get('category_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        categoryDialog(data) {
            dispatch(categoryDialog(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectCategory(data){
            dispatch(selectCategory(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CategoryDialog);


// WEBPACK FOOTER //
// ./src/components/inventories/CategoryDialog.js